module.exports = __webpack_public_path__ + "img/user.cbd1f84b.png";